import { useContext } from "react";
import { useMutation } from "react-query";
import { ApiContext } from "../../contexts/ApiContext";
import { HvSubstation2Submission } from "../../shared/interfaces/HvSubstation";

export function useHvSubstationCreation() {
  const apiContext = useContext(ApiContext);
  return useMutation(["submitHvSubstation"], async (substationSubmission: HvSubstation2Submission) =>
    apiContext.hvSubstationApis.createHvSubstation(substationSubmission),
  );
}
